import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Cookie from "js-cookie";
const userToken = Cookie.get("token");
const baseUrl = process.env.VUE_APP_BASE_API_URL;
Vue.use(VueAxios, axios);

Vue.use(axios);

const getSHUlist = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/shu/list", {
        params: {
          order_by: "date",
          order_direction: "desc",
          last_years: null,
          starting_year: state.start_year,
          ending_year: state.end_year
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESSHULIST", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getChartSHU = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/shu/chart", {
        params: {
          order_by: "date",
          order_direction: "asc",
          last_years: null,
          starting_year: state.start_year,
          ending_year: state.end_year
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESCHARTSHU", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getDownloadShu = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/shu/report", {
        params: {
          order_by: "date",
          order_direction: "asc",
          last_years: null,
          starting_year: state.start_year,
          ending_year: state.end_year,
          noa: null,
          filename: "SHU-Report.xlsx"
        },
        headers: {
          authorization: `Bearer ${userToken}`,
          "Accept": "application/vnd.ms-excel"
        },
        responseType: "blob"
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESFILESHU", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  getSHUlist,
  getChartSHU,
  getDownloadShu
};
